/*
 * Ryan O'Dowd
 * 2025-05-26
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import useTypedSelector from './useTypedSelector';

export default function usePreferredTranslation() {
  return useTypedSelector((state) => {
    const translation = state.translations.find((translation) => translation.id === (state.userSettings.preferred_translation_id || 3));
    if (translation) {
      return translation;
    }

    return {}; // this should only be the case if state.translations hasn't been loaded yet
  });
}
